<template>
  <div class="2">
    <!-- Main table element -->
    <b-table
      :class="'actions-table'"
      :items="items"
      :fields="fields"
      :current-page="currentPage"
      :per-page="perPage"
      :filter="filter"
      :fixed="false"
      :sort-by.sync="sortBy"
      :sort-desc.sync="sortDesc"
      :sort-direction="sortDirection"
      stacked="md"
      show-empty
      @filtered="onFiltered"
    >

      <template #cell(actions)="row">
        <b-dropdown right>
          <template #button-content>
            <i class="fa-solid fa-ellipsis"></i>
          </template>
          <b-dropdown-item>Edit</b-dropdown-item>
          <b-dropdown-item>Delete</b-dropdown-item>
        </b-dropdown>
      </template>

      <template #row-details="row">
        <b-card>
          <ul>
            <li v-for="(value, key) in row.item" :key="key">{{ key }}: {{ value }}</li>
          </ul>
        </b-card>
      </template>

      <template #cell(status)="row">
        <span v-html="getStatusHtml(row.value)"></span>
      </template>

    </b-table>

    <!-- Info modal -->
    <b-modal :id="infoModal.id" :title="infoModal.title" ok-only @hide="resetInfoModal">
      <pre>{{ infoModal.content }}</pre>
    </b-modal>
  </div>
</template>

<script>
export default {
  data () {
    return {
      items: [
        { code: 'E660', type: 'Online', status: false, email: 'test@test.se', name: { first: 'Mitzi', last: 'Navarro' } },
        { code: 'E660', type: 'Online', status: false, email: 'test@test.se', name: { first: 'Genevieve', last: 'Wilson' } },
        { code: 'E660', type: 'Online', status: true, email: 'test@test.se', name: { first: 'John', last: 'Carney' }, _cellVariants: { status: 'danger' } },
        { code: 'E660', type: 'Online', status: false, email: 'test@test.se', name: { first: 'Dick', last: 'Dunlap' } }
      ],
      fields: [
        { key: 'code', label: 'Code', sortable: true, sortDirection: 'desc' },
        { key: 'email', label: 'E-mail', sortable: true, class: 'email-column' },
        { key: 'type', label: 'Form Type', sortable: true },
        { key: 'status', label: 'Status', sortable: true, sortByFormatted: true, filterByFormatted: true },
        { key: 'actions', label: 'Actions', class: 'ellipsis-button' }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 5,
      pageOptions: [5, 10, 15, { value: 100, text: 'Show a lot' }],
      sortBy: '',
      sortDesc: false,
      sortDirection: 'asc',
      filter: null,
      filterOn: [],
      infoModal: {
        id: 'info-modal',
        title: '',
        content: ''
      }
    }
  },
  computed: {
    sortOptions () {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => {
          return { text: f.label, value: f.key }
        })
    }
  },
  mounted () {
    // Set the initial number of items
    this.totalRows = this.items.length
  },
  methods: {
    info (item, index, button) {
      this.infoModal.title = `Row index: ${index}`
      this.infoModal.content = JSON.stringify(item, null, 2)
      this.$root.$emit('bv::show::modal', this.infoModal.id, button)
    },
    resetInfoModal () {
      this.infoModal.title = ''
      this.infoModal.content = ''
    },
    onFiltered (filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length
      this.currentPage = 1
    },
    getStatusHtml (value) {
      return !value ? 'Sent' : 'Not sent <a class="ml-1">Send invitation</a>'
    }
  }
}
</script>

<style>
  .email-column {
    width: 100%;
  }
  .b-table thead th {
    white-space: nowrap;
  }
  .b-table tbody td {
    white-space: nowrap;
  }
  .b-table tbody td.email-column {
    width: auto;
  }
</style>
